import React from 'react';
import './WhyTalyfax.css';

const WhyTalyfax = () => {
  return (
    <div className="why-page">
      {/* Hero */}
      <section className="why-hero">
        <h1>Why Choose Talyfax</h1>
        <p>We architect digital solutions that scale, secure, and elevate your business.</p>
      </section>

      {/* Core Benefits */}
      <section className="why-benefits">
        <div className="benefit">
          <h3>🔧 Scalable Tech</h3>
          <p>From web platforms to mobile apps and AI tools, we build systems that grow with you.</p>
        </div>
        <div className="benefit">
          <h3>🎯 Strategic Design</h3>
          <p>We align branding, UX, and infrastructure to deliver clarity and credibility.</p>
        </div>
        <div className="benefit">
          <h3>🚀 Fast Deployment</h3>
          <p>Optimized CI/CD pipelines and cloud hosting for speed, uptime, and reliability.</p>
        </div>
        <div className="benefit">
          <h3>🔐 Security Hygiene</h3>
          <p>We proactively audit dependencies and enforce best practices to protect your stack.</p>
        </div>
      </section>

      {/* Philosophy */}
      <section className="why-philosophy">
        <div className="philosophy-icon">🤝</div>
        <div className="philosophy-text">
          <h2>Our Philosophy</h2>
          <p>
            Talyfax isn’t just a tech vendor—we’re your strategic partner. We believe in modular,
            future-proof systems that empower teams, reduce friction, and elevate brand trust.
          </p>
        </div>
      </section>

      {/* CTA */}
      <section className="why-cta">
        <h2>Let’s Build Your Digital Advantage</h2>
        <a href="/contact" className="cta-button">Request a Quote</a>
      </section>
    </div>
  );
};

export default WhyTalyfax;
